import { of, Observable, noop } from 'rxjs';
import { switchMap, tap, retry, filter } from 'rxjs/operators';
import * as RA from 'ramda-adjunct';

export interface WrapConfig<T> {
    before: () => void;
    source$: Observable<T>;
    after?: (sourceSignal: T) => void;
}

export function wrap<T>(config: WrapConfig<T>): Observable<T> {
    const before$ = of(null).pipe(tap(config.before));
    return before$.pipe(switchMap(() => config.source$.pipe(tap(config.after || noop))));
}

export const standardRetry = () => (source$: Observable<any>) => source$.pipe(retry(1));

export const whenTrue = (source$: Observable<any>) => source$.pipe(filter(RA.isTrue));
export const whenFalse = (source$: Observable<any>) => source$.pipe(filter(RA.isFalse));

export const isTrue = () => whenTrue;
export const isFalse = () => whenFalse;
